import { MutationTree, ActionTree, ActionContext, GetterTree } from "vuex";
import { RootState } from "@/store";
import LoggerService from "@/services/loggerService";
import { ReleaseNotes } from "@/models/releaseNotes";
import cmsService from "@/services/cmsService";
import FileService from "@/services/fileService";
import cloneDeep from "lodash/cloneDeep";
import { DirectLink } from "@/models/directLinks";

export interface CmsState {
  releaseNotes: ReleaseNotes[];
  directLinks: DirectLink[];
  loading: boolean;
}

type AppContext = ActionContext<CmsState, RootState>;

export const namespaced = true;

const initialState = {
  releaseNotes: [],
  directLinks: [],
  loading: false,
};

export const state = (): CmsState => cloneDeep(initialState);

export const getters: GetterTree<CmsState, RootState> = {
  releaseNotes: (state) => {
    return state.releaseNotes;
  },
  directLinks: (state) => {
    return state.directLinks;
  },
  loading: (state): boolean => {
    return state.loading;
  },
};

export const mutations: MutationTree<CmsState> = {
  setReleaseNotes(state: CmsState, notes: ReleaseNotes[]) {
    state.releaseNotes = notes;
  },
  setLoading(state: CmsState, loading: boolean) {
    state.loading = loading;
  },
};

export const actions: ActionTree<CmsState, RootState> = {
  async reset(context: AppContext): Promise<void> {
    const s = cloneDeep(initialState);
    context.state.releaseNotes = s.releaseNotes;
    context.state.loading = s.loading;
  },
  async fetchReleaseNotes(context: AppContext): Promise<void> {
    if (context.state.releaseNotes.length == 0) {
      try {
        context.commit("setLoading", true);
        const res = await cmsService.getReleaseNotes();
        res.map(async (r) => {
          if (!r.url && r.product == "room") {
            r.url = await FileService.latestVersion(r.fastChannel);
          }
          return r;
        });

        context.commit("setReleaseNotes", res);
      } catch (e) {
        LoggerService.error(e);
      } finally {
        context.commit("setLoading", false);
      }
    }
  },
  async fetchDirectLinks(context: AppContext): Promise<void> {
    if (context.state.directLinks.length == 0) {
      try {
        context.commit("setLoading", true);
        const res = await cmsService.getDirectLinks();
        context.state.directLinks = res;
      } catch (e) {
        LoggerService.error(e);
      } finally {
        context.commit("setLoading", false);
      }
    }
  },
};
